import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { queryStringForAlertResult } from "@app2/alert/alert-inbox/utils";
import { Alert, QueryTrigger } from "@app2/clients/types/alert-typedefs";
import { SavedQueryService } from "@app2/search/saved-query.service";
import { SavedQuery } from "@app2/type-defs/search/search-types";
import * as moment from "moment";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

@Component({
    selector: "alert-events-table",
    template: `
        <div class="small-16 columns limit-results-height">
            <events-table [queryString]="queryStringForAlertResult(trigger, savedQuery$ | async, alert)"
                          [begin]="begin"
                          [end]="end"
                          [filterList]="{ field: trigger.filterField, id: trigger.filterListId }"
                          [excludeList]="{ field: trigger.excludeField, id: trigger.excludeListId }"
                          [customColumns]="trigger.customHeaders">
            </events-table>
        </div>
    `,
    host: {
        class: "flex-container",
    },
    styles: [`
        .columns {
            padding: 0;
        }
    `],
})
export class AlertEventsTableComponent implements OnChanges {
    @Input() alert: Alert;
    @Input() trigger: QueryTrigger;

    begin: Moment;
    end: Moment;
    savedQuery$: Observable<SavedQuery>;

    constructor(private readonly savedQueryService: SavedQueryService) {}

    ngOnChanges(changes: SimpleChanges) {
        this.begin = moment(this.alert.resultTimestamp);
        this.end = this.alert.resultEndTimestamp
            ? moment(this.alert.resultEndTimestamp)
            : moment(this.alert.resultTimestamp).add(1, "days");

        if (changes.trigger) {
            this.savedQuery$ = this.trigger?.savedQueryId
                ? this.savedQueryService.getSavedQuery$(this.trigger.savedQueryId)
                    .pipe(shareReplay(1))
                : null;
        }
    }

    queryStringForAlertResult = queryStringForAlertResult;
}
